export const configPathQueryParam = 'config_path'
